export class InsufficientCreditsError extends Error {
  public insufficientCredits: boolean;

  constructor(message: string) {
    super(message);
    this.name = "InsufficientCreditsError";
    this.insufficientCredits = true;
  }
}
